<template>
    <div class="header">
      <!-- <invoice-type v-model:code="listQuery.fplxdm"></invoice-type> -->
      <!-- <el-button :loading="loading" type="primary" size="mini" @click="search">查询</el-button> -->
      <el-button :loading="loading" type="primary" size="mini" @click="fenfa">分发</el-button>
    </div>
    <div class="home">
        <el-table ref="singleTable" :data="tableData" highlight-current-row border @selection-change="handleSelectionChange" style="width: 100%" :header-cell-style="{background:'#66b1ff',color:'#ffff'}" size="mini">
         <el-table-column type="selection" width="55" align="center"> </el-table-column>
         <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
         <!-- <el-table-column property="fplxdm" label="发票类型代码" align="center"></el-table-column> -->
         <el-table-column label="发票类型" width="160" align="center">
          <template v-slot="scope">
            <span>{{ $fplx(scope.row.fplxdm) }}</span>
          </template>
         </el-table-column>
         <el-table-column property="fpdm" label="发票代码" align="center"></el-table-column>
         <el-table-column property="qshm" label="起始号码" align="center"></el-table-column>
         <el-table-column property="zzhm" label="终止号码" align="center"></el-table-column>
         <el-table-column property="fpfs" label="发票份数" align="center"></el-table-column>
         <el-table-column label="购票状态" align="center">
           <template v-slot="scope">
             <span>{{findgpzt(scope.row.gpzt)}}</span>
           </template>
         </el-table-column>
         <el-table-column fixed="right" label="操作" width="100">
          <template #default="scope">
            <el-button @click="distributeApply(scope.row)" type="text" size="mini" plain>分发</el-button>
          </template>
         </el-table-column>
        </el-table>
  </div>
  

</template>
<script>
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { applyFpList, applyDistribute } from "@/api/apply";
export default {
  name: 'InvoiceApplyList',
  created () {
    this.getList()
  },
  data(){
    return {
      loading: false,
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
      },
      tableData: [],
      selects: [],
    }
  },
  methods:{
    handleSelectionChange(e){
      this.selects = e
      console.log(this.selects)
    },
    fenfa(){
      if(this.selects.length == 0){
        this.$qzfMessage("请至少选择一条", 1)
        return
      }
      this.$confirm('确定分发?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        applyDistribute(this.selects).then(res=>{
          if(res.data.msg == "success"){
            this.getList()
            this.$qzfMessage("分发成功")
          }
        })
      })
    },
    distributeApply(row){
      this.$confirm('确定分发?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        applyDistribute([row]).then(res=>{
          if(res.data.msg == "success"){
            this.getList()
            this.$qzfMessage("分发成功")
          }
        })
      })
    },
    //获取列表
    getList(){
      this.loading = true
      applyFpList(this.listQuery).then(res=>{
        this.loading = false
        if(res.data.data.list){
          this.tableData = res.data.data.list
        }
      })
    },
    findgpzt(e){
      if(e == "0"){
        return "待分发"
      }else if(e == "1"){
         return "分发中"
      }else if(e == "2"){
        return "已分发"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.header{
  text-align: right;
  padding: 10px 10px 10px 10px;
}
</style>